<i class="fa fa-circle-o-notch fa-spin fa-4x"></i>